import React from 'react'

import AiListeningIndicator from '../voice/AiListeningIndicator.tsx'
import AiMutedIndicator from '../voice/AiMutedIndicator.tsx'
import AiSpeakingIndicator from '../voice/AiSpeakingIndicator.tsx'
import AiThinkingIndicator from '../voice/AiThinkingIndicator.tsx'

type Props = {
  isUserSpeaking?: boolean
  isAiSpeaking?: boolean
  isAiThinking?: boolean
  isListening?: boolean
  isMuted?: boolean
  volumeLevel?: number
  label?: string
  compact?: boolean
  className?: string
  isEntering?: boolean
  isExiting?: boolean
}

const AiAgentCircle: React.FC<Props> = ({
  isUserSpeaking,
  isAiSpeaking,
  isAiThinking = false,
  isListening = false,
  isMuted = false,
  volumeLevel = 0,
  label = 'AI Agent',
  compact = false,
  className = '',
  isEntering = false,
  isExiting = false,
}) => {
  const wrapCls =
    `ai-circle-wrap ${compact ? 'compact' : ''} ${isMuted ? 'muted' : ''} ${className}`.trim()
  const circleCls =
    `ai-circle ${isUserSpeaking ? 'user-speaking' : ''} ${isMuted ? 'muted' : ''} ${compact ? 'compact' : ''} ${className}`.trim()
  const indicatorCls = compact ? 'compact' : className

  return (
    <div className={wrapCls} aria-hidden={false}>
      <AiMutedIndicator isMuted={isMuted} compact={compact} />

      <AiListeningIndicator
        isListening={isListening && !isMuted}
        volumeLevel={volumeLevel}
        compact={compact}
        className={indicatorCls}
        isEntering={isEntering}
        isExiting={isExiting}
      />

      <AiSpeakingIndicator
        isSpeaking={!!isAiSpeaking && !isMuted}
        compact={compact}
        className={indicatorCls}
        isEntering={isEntering}
        isExiting={isExiting}
      />

      <AiThinkingIndicator
        isThinking={isAiThinking && !isMuted}
        compact={compact}
        className={indicatorCls}
      />

      <div className={circleCls} role='img' aria-label={label}>
        {label}
      </div>
    </div>
  )
}

export default React.memo(AiAgentCircle)
